/**
 * Visits Tab Component
 * Visit scheduling for RN Command Center
 */

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Calendar, Clock } from "lucide-react";

const VisitsTab = ({
  isDark,
  visits
}) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <Card className={isDark ? "bg-slate-800/50 border-slate-700" : "bg-white border-gray-200 shadow-sm"}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-blue-500" />
            Today&apos;s Schedule
          </CardTitle>
          <CardDescription>{visits?.today || 0} visits scheduled today</CardDescription>
        </CardHeader>
        <CardContent>
          <p className={`text-center py-8 ${isDark ? "text-slate-400" : "text-gray-500"}`} data-testid="today-visits-count">
            {visits?.today || 0} visits scheduled for today
          </p>
        </CardContent>
      </Card>
      
      <Card className={isDark ? "bg-slate-800/50 border-slate-700" : "bg-white border-gray-200 shadow-sm"}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-amber-500" />
            This Week
          </CardTitle>
          <CardDescription>{visits?.this_week || 0} total • {visits?.overdue || 0} overdue</CardDescription>
        </CardHeader>
        <CardContent>
          <p className={`text-center py-8 ${isDark ? "text-slate-400" : "text-gray-500"}`} data-testid="week-visits-count">
            {visits?.this_week || 0} visits this week
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default VisitsTab;
